import ToolbarItemBasic from "toolbar/ToolbarItemBasic";

class ToolbarItemLink extends ToolbarItemBasic {

    constructor(text, location, icon = '', active = false) {
        super(text, (e) => e.stopPropagation() || true, icon, active);
        this.location = location;
    }

    getHref() {
        return this.location;
    }

}


export default ToolbarItemLink;
